import { styled } from "baseui";

export const Subheading = styled("h3", ({ $theme }) => ({
  ...$theme.typography.LabelMedium,
  fontWeight: 700,
  color: $theme.colors.contentPrimary,
}));
